<template>
  <div class="flex-grid">
    <div class="col2">
      <div class="main_heading">
        <h3>Create Menu</h3>
        <a
          class="button_create"
          href="/menus/"
        >Manage Menus</a>
      </div>
      <h2 />
      <div class="form-fields">
        <label for="roleName">
          <b>Select Menu Type:</b>
        </label>
        Menu
        <input
          v-model="menuType"
          type="radio"
          value="menu"
        >
        Sub Menu
        <input
          v-model="menuType"
          type="radio"
          value="submenu"
        >
      </div>
      <div
        v-if="menuType=='submenu'"
        class="form-fields"
      >
        <label for="roleName">
          <b>Select Parent Menu</b>
        </label>
        <select v-model="parentMenuId">
          <option value>
            Select Parent Menu
          </option>
          <option
            v-for="(menu, key) in parentMenus"
            :key="key"
            :value="menu._id"
          >
            {{ menu.menu_name }}
          </option>
        </select>
      </div>
      <div class="form-fields">
        <label for="menuName">
          <b>Menu Name*</b>
        </label>
        <input
          v-model="menuName"
          type="text"
          placeholder="Enter Menu name"
          name="menuName"
          required
        >
      </div>
      <div class="form-fields">
        <label for="menuName">
          <b>Menu Controller</b>
        </label>
        <input
          v-model="menuController"
          type="text"
          placeholder="Enter Controller Name"
          name="menucontroller"
          required
        >
      </div>
      <div class="form-fields">
        <label for="menuName">
          <b>Menu URL*</b>
        </label>
        <input
          v-model="menuURL"
          type="text"
          placeholder="Enter URL"
          name="menuurl"
          required
        >
      </div>
      <div class="form-fields">
        <label for="menuName">
          <b>Menu Description*</b>
        </label>
        <input
          v-model="menuDescription"
          type="text"
          placeholder="Enter Description"
          name="menuDescription"
          required
        >
      </div>
      <a
        class="button_create"
        @click="createMenu()"
      >{{ btnName }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CreateMenus',
  components: {},
  data() {
    return {
      isUpdate: false,
      menuType: 'submenu',
      parentMenuId: '',
      parentMenus: [],
      menuName: '',
      menuController: '',
      menuURL: '',
      menuDescription: '',
      btnName: 'Create',
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.btnName = 'Update';
      this.isUpdate = true;
      const getRole = fetch(`/api/menus/${this.$route.query.id}`, {
        credentials: 'same-origin',
      });
      getRole
        .then(data => data.json())
        .then((data) => {
          this.menuName = data.menu_name;
          this.menuController = data.menu_url;
          this.menuURL = data.menu_url;
          this.menuDescription = data.menu_description;
          this.parentMenuId = data.parent_menu_id;
          if (data.parent_menu_id === '0') {
            this.menuType = 'menu';
          }
        });
    }
    const getMenus = fetch('/api/menus/all', { credentials: 'same-origin' });
    getMenus
      .then(data => data.json())
      .then((data) => {
        this.parentMenus = data.filter((menu) => {
          if (menu.parent_menu_id === '0') {
            return menu;
          }
          return true;
        });
      });
  },
  methods: {
    createMenu() {
      if (this.menuType === 'submenu' && this.parentMenuId === '') {
        this.$toasted.error('Please Select Menu', { duration: 3000 });
        return true;
      }
      if (this.menuName === '') {
        this.$toasted.error('Please Enter Menu Name', { duration: 3000 });
        return true;
      }
      if (this.menuURL === '') {
        this.$toasted.error('Please Enter URL', { duration: 3000 });
        return true;
      }
      if (this.menuDescription === '') {
        this.$toasted.error('Please Enter Description', { duration: 3000 });
        return true;
      }
      let url = '/api/createMenu';
      // let data = {roleName: this.roleName}
      if (this.menuType === 'menu') {
        this.parentMenuId = 0;
      }
      const data = {
        parentMenu: this.parentMenuId,
        menuName: this.menuName,
        menuDescription: this.menuDescription,
        menuUrl: this.menuURL,
      };
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/createMenu/${this.$route.query.id}`;
      }
      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }));
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col2 {
  width: 100%;
}
</style>
